import { useMutation } from '@tanstack/react-query';
import UserService from 'api/services/httpServices/UserService';
import { Button } from 'modules/shared-components/button/button';
import { ApiErrorNotification } from 'modules/shared-components/notification/ApiErrorNotification';

export function ResendCodeViaEmail() {
  const {
    mutate: sendCode,
    error: sendCodeError,
    isLoading: isResending,
    isSuccess: isResentSuccess,
  } = useMutation({
    mutationFn: UserService.sendOtpCodeViaMail,
  });

  return (
    <>
      <div className="flex flex-row xxs:gap-2 items-center justify-end">
        {isResentSuccess ? (
          <span className="text-green-success xxs:my-2">
            Email with code sent. Check your email.
          </span>
        ) : (
          <>
            <span className="dark:text-white-600">
              Did not receive an email?
            </span>{' '}
            <Button
              className="text-mizar-blue-500 xxs:px-1 normal-case"
              loading={isResending}
              type="button"
              onClick={() => {
                sendCode();
              }}
            >
              Resend
            </Button>
          </>
        )}
      </div>

      <ApiErrorNotification error={sendCodeError} className="xxs:my-2" />
    </>
  );
}
